import {
  TIDE_RATE_DATA_CREATE_IN_PROGRESS,
  TIDE_RATE_DATA_CREATE_SUCCESS,
  TIDE_RATE_DATA_CREATE_ERROR,
} from 'src/store/tideRateData/actions'

export const reducer = (state = {}, action) => {
  const { type, payload, error } = action
  switch (type) {
    case TIDE_RATE_DATA_CREATE_IN_PROGRESS:
    case TIDE_RATE_DATA_CREATE_SUCCESS: {
      const { tideRateStation: { uuid } = {} } = payload
      return {
        ...state,
        [uuid]: type,
      }
    }
    case TIDE_RATE_DATA_CREATE_ERROR: {
      const { payload: { tideRateStation: { uuid } = {} } = {} } = error
      return uuid
        ? {
            ...state,
            [uuid]: type,
          }
        : state
    }
    default:
      return state
  }
}

export default reducer
